/**
 * Team Member List Alpine Component
 *
 * Drives the filterable team member grid and bio drawer.
 *
 * Filtering uses a two-phase transition to avoid the abrupt grid reflow
 * that occurs when individual cards get display:none mid-animation:
 *   1. Fade the entire grid out (FADE_DURATION ms)
 *   2. Swap activeFilter while the grid is invisible — layout reflows here
 *   3. Fade the grid back in showing only the matching cards
 *
 * The bio drawer is controlled via `activeMember` (null = closed, id = open).
 * Body scroll is locked while the drawer is open.
 */

const FADE_DURATION = 200; // ms — matches the CSS transition-duration on the grid wrapper

export function teamMemberList() {
  return {
    activeFilter: 'all',
    activeMember: null,
    isTransitioning: false,

    init() {
      this.$watch('activeMember', (value) => {
        if (value !== null) {
          window.lenis?.stop();
        } else {
          window.lenis?.start();
        }
      });
    },

    filter(slug) {
      const target = slug || 'all';
      if (target === this.activeFilter || this.isTransitioning) return;

      // Phase 1: fade grid out
      this.isTransitioning = true;

      setTimeout(() => {
        // Phase 2: swap filter (grid is invisible — reflow is hidden)
        this.activeFilter = target;

        // Phase 3: fade grid back in after Alpine has applied x-show changes
        this.$nextTick(() => {
          this.isTransitioning = false;
        });
      }, FADE_DURATION);
    },
  };
}

window.teamMemberList = teamMemberList;
